var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSignature = function SvgSignature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M0 18.2c0 1.1.9 2 2 2h2.6L0 15.6zM19.6 3.8 16.4.6c-.8-.8-2-.8-2.8 0l-.2.2c-.4.4-.4 1 0 1.4L18 6.8c.4.4 1 .4 1.4 0l.2-.2c.8-.8.8-2 0-2.8M12 3.6c-.4-.4-1-.4-1.4 0l-9.1 9.1c-.5.5-.5 1.1-.1 1.5L6 18.8c.4.4 1 .4 1.4 0l9.1-9.1c.4-.4.4-1 0-1.4z"
  })));
};
export default SvgSignature;